module.exports = __webpack_public_path__ + "img/axis-realty-group-video-bg.6938c8e7.jpg";